// extracted by mini-css-extract-plugin
module.exports = {"resultDeclarationDisplay":"ResultDeclarationDisplay_resultDeclarationDisplay__dnyrv"};